import React from 'react';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';
import { colors } from '@hydra/common/styles';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '50%',
    border: '1px solid',
    display: 'inline-block',
    fontWeight: theme.typography.fontWeightSemibold,
    letterSpacing: '-1px',
    textAlign: 'center',
    verticalAlign: 'middle'
  },
  xs: {
    width: 5,
    height: 5
  },
  sm: {
    width: 10,
    height: 10,
    lineHeight: 10
  },
  md: {
    width: 13,
    height: 13,
    lineHeight: 13
  },
  default: {
    width: 15,
    height: 15,
    lineHeight: 15
  },
  lg: {
    width: 18,
    height: 18,
    lineHeight: 18
  },
  xxl: {
    width: 30,
    height: 30,
    lineHeight: 30
  }
}));

type DotSize = 'xs' | 'sm' | 'md' | 'base' | 'default' | 'lg' | '2x';

export default function Dot ({
  className: classNameProp,
  color = colors.primary.main,
  size = 'md'
}: {
  className?: string
  color: string
  size?: DotSize
}) {
  const classes = useStyles();

  const dotStyle = {
    backgroundColor: color,
    borderColor: color
  };

  const className = classnames(
    classes.root,
    {
      [classes.xs]: size === 'xs',
      [classes.sm]: size === 'sm',
      [classes.md]: size === 'md',
      [classes.default]: size === 'default',
      [classes.lg]: size === 'lg',
      [classes.xxl]: size === '2x'
    },
    classNameProp
  );

  return (
    <span className={className} style={dotStyle} />
  );
}
